import { useEffect } from 'react'

const PIXEL_ID = '2832673310418578'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

export function useMetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    try {
      if (window.fbq) {
        try {
          window.fbq('track', 'PageView')
        } catch (e) {
          // silent fail in restricted environments
        }
        return
      }

      /* eslint-disable */
      !(function (f: any, b: any, e: string, v: string) {
        if (f.fbq) return
        const n: any = (f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments)
        })
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        const t: any = b.createElement(e)
        t.async = !0
        t.onerror = function () {
          /* silent fail */
        }
        t.src = v
        const s: any = b.getElementsByTagName(e)[0]
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s)
        } else {
          b.head.appendChild(t)
        }
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js',
      )
      /* eslint-enable */

      try {
        window.fbq('init', PIXEL_ID)
        window.fbq('track', 'PageView')
      } catch (e) {
        // silent fail
      }
    } catch (e) {
      console.warn('Meta Pixel could not be initialized:', e)
    }
  }, [])
}

interface InitiateCheckoutPayload {
  plan: 'esencial' | 'completo'
  value: number
  currency?: string
}

export function trackInitiateCheckout({
  plan,
  value,
  currency = 'ARS',
}: InitiateCheckoutPayload) {
  if (typeof window === 'undefined') return
  try {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name:
          plan === 'esencial' ? 'AirPack Esencial' : 'AirPack Completo',
        content_category: 'AirPack',
        content_ids: [plan],
        value,
        currency,
      })
    }
  } catch (e) {
    // silent fail
  }
}

export function trackViewContent() {
  if (typeof window === 'undefined') return
  try {
    if (window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_name: 'AirPack Pricing',
        content_category: 'AirPack',
        currency: 'ARS',
      })
    }
  } catch (e) {
    // silent fail
  }
}
